<template>
  <div class="tw-h-full tw-flex tw-flex-col tw-flex-1 tw-overflow-hidden" @click="readAllMessages">
    <div v-if="loading" class="tw-flex-1 tw-flex tw-items-center">
      <img :src="loadingAsset" class="tw-mx-auto">
    </div>
    <div v-if="!loading && groupedMessages.length > 0" ref="messagesContainer" class="tw-flex tw-flex-col tw-flex-1 tw-relative tw-overflow-auto tw-pb-2 tw-px-4 scrollbar-thin">
      <section v-for="groupedDay in groupedMessages" :key="groupedDay.date">
        <div class="tw-relative">
          <hr class="tw-w-full tw-border-ugray-200 tw-absolute tw-left-0 tw--translate-y-1/2 tw-top-1/2 ">
          <h1 class="tw-py-4 tw-text-center tw-text-sm tw-text-ugray-600 tw-bg-white tw-px-2 tw-relative tw-z-10 tw-w-max tw-mx-auto tw-font-medium">{{ groupedDay.date }}</h1>
        </div>

         <message v-for="(message, index) in groupedDay.messages"
          :key="message.id"
          :time="showTime(message, index, groupedDay.messages)"
          :send-by-me="currentProfessional.id == message.professional_id"
          :message="message">
        </message>
      </section>
    </div>
    <div v-if="!loading && groupedMessages.length === 0" class="tw-flex-1 tw-items-center tw-justify-center tw-flex tw-flex-col">
      <img :src="noMessagesAsset">
      <p class="tw-mt-4 tw-text-sm tw-text-ugray-600 tw-leading-5 tw-text-center">Você ainda não trocou mensagens com esta pessoa</p>
    </div>
    <form @submit.prevent="sendMessage" v-if="!loading" class="tw-mt-auto tw-p-4 tw-flex tw-gap-3 tw-bg-white tw-w-full tw-border-t tw-border-ugray-200 tw-rounded-b-lg tw-items-start">
      <textarea
        type="text"
        v-model="message"
        placeholder="Mensagem"
        ref="messageInput"
        :rows="messageRows"
        @keydown="handleMessageKeyDown"
        @focusin="messageInputFocused = true"
        @focusout="messageInputFocused = false"
        class="tw-resize-none tw-w-full tw-py-2.5 tw-px-3.5 tw-flex-1 tw-shadow-uxs tw-rounded-lg tw-border tw-border-ugray-300 placeholder:tw-text-base placeholder:tw-text-ugray-500 placeholder:tw-leading-6 tw-text-base tw-text-ugray-900 tw-leading-6 scrollbar-thin" />
      <button class="tw-bg-ublue-500 tw-rounded-lg tw-shadow-uxs tw-p-3 tw-border-ublue-500 tw-border" type="submit">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.75036 10H4.16702M4.09648 10.243L2.15071 16.0552C1.99785 16.5118 1.92142 16.7401 1.97627 16.8807C2.0239 17.0028 2.1262 17.0954 2.25244 17.1306C2.3978 17.1712 2.61736 17.0724 3.05647 16.8748L16.9827 10.608C17.4113 10.4151 17.6256 10.3187 17.6918 10.1847C17.7494 10.0683 17.7494 9.93176 17.6918 9.81537C17.6256 9.6814 17.4113 9.58497 16.9827 9.39209L3.05161 3.12314C2.61383 2.92614 2.39493 2.82764 2.24971 2.86804C2.1236 2.90314 2.0213 2.99546 1.97351 3.11733C1.91847 3.25766 1.99408 3.48547 2.14531 3.9411L4.09702 9.82131C4.12299 9.89957 4.13598 9.9387 4.14111 9.97871C4.14565 10.0142 4.14561 10.0502 4.14097 10.0857C4.13574 10.1257 4.12265 10.1648 4.09648 10.243Z" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </form>
  </div>
</template>

<script>
import axios from "axios";
import { isToday } from 'date-fns'
import Message from "./message.vue"
import ptBR from "date-fns/locale/pt-BR";
import { format as formatDate } from "date-fns";
import { generateRandomString } from "../../helpers/string";

axios.defaults.headers.common = {
  "X-Requested-With": "XMLHttpRequest",
  "X-CSRF-Token": document
    .querySelector("meta[name=csrf-token]")
    .getAttribute("content"),
};

function formatDatePtBr(date, format){
  return formatDate(
    date,
    format,
    {
      locale: ptBR,
    }
  )
}

function encodeHTMLEntities(text) {
  var textArea = document.createElement('textarea');
  textArea.innerText = text;
  return textArea.innerHTML;
}

export default {
  props: ["selectedProfessional", "currentProfessional", "loadingAsset", "noMessagesAsset"],
  components: {Message},
  data() {
    return {
      loading: false,
      open: false,
      loaded: false,
      message: "",
      messageRows: 1,
      messageInputFocused: false,
    };
  },
  mounted() {
    this.getMessages(this.selectedProfessional.chat_conversation_id);
    if (this.selectedProfessional.loadedMessages && this.selectedProfessional.messages.length > 0) {
      this.scrollBottom();
      this.$nextTick(() => {
        this.$refs.messageInput.focus();
      })
    }
  },
  watch: {
    "selectedProfessional.messages"(){
      this.scrollBottom();
      if (this.messageInputFocused && this.hasUnreadMessagesByMe) {
        this.readAllMessages()
      }
    },
  },
  methods: {
    scrollBottom(){
      this.$nextTick(() => {
        this.$refs.messagesContainer.scrollTop = this.$refs.messagesContainer.scrollHeight;
      });
    },
    async getMessages(conversation_id) {
      if (!conversation_id) return;
      if (this.selectedProfessional.loadedMessages) {
        if (this.selectedProfessional.unread_messages_count > 0) {
          this.$emit("mark-as-read", this.selectedProfessional)
        }
        return
      };
      this.loading = true;
      try {
        const response = await axios.get(
          `/chat/conversations/${conversation_id}`
        );
        this.$emit(
          "messages",
          {
            ...this.selectedProfessional,
            messages: response.data.data.messages,
            loadedMessages: true,
          }
        );
        this.scrollBottom();
        this.$nextTick(() => {
          this.$refs.messageInput.focus();
        })
        if (this.selectedProfessional.unread_messages_count > 0) {
          this.$emit("mark-as-read", this.selectedProfessional)
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
        this.loaded = true;
      }
    },
    async sendMessage() {
      if (!this.message) { return }
      const localId = generateRandomString(10)
      const messageContent = this.message;
      const localMessage = {
        content: encodeHTMLEntities(messageContent),
        created_at: new Date(),
        id: null,
        professional_id: this.currentProfessional.id,
        send_by_me: true,
        status: "sending",
        updated_at: new Date(),
        local_id: localId,
      }
      try {
        this.$emit(
          "append-message",
          this.selectedProfessional,
          localMessage
        );
        this.message = "";
        this.messageRows = 1;
        const response = await axios.post(`/chat/messages/`, {
          chat_message: {
            content: messageContent,
            chat_conversation_id: this.selectedProfessional.chat_conversation_id,
            local_chat_conversation_id: this.selectedProfessional.local_chat_conversation_id,
            professional_id: this.selectedProfessional.id,
            local_id: localId,
          },
          local_id: localId,
        });

        this.$emit(
          "append-message",
          this.selectedProfessional,
          {
            ...response.data.data.message,
            local_id: localId,
          }
        );
        this.loading = false;
      } catch (error) {
        console.error(error);
        this.$emit(
          "append-message",
          this.selectedProfessional,
          {...localMessage, status: "error"}
        );
        if (typeof Bugsnag !== 'undefined') {
          Bugsnag.notify(error)
        }
      }
    },
    formatDate(date){
      if (isToday(date)) {
        return "Hoje"
      }

      return formatDate(
        date,
        "dd MMM',' yyyy",
        {
          locale: ptBR,
        }
      )
    },
    differenceOfTimeInMinutes(firstDate, secondDate){
      return (firstDate - secondDate) / 1000 / 60;
    },
    showTime(message, index, messages){
      if (index == 0 || message.professional_id != messages[index - 1].professional_id) {
        return formatDate(
          message.createdAt,
          "HH:mm",
          {
            locale: ptBR,
          }
        )
      }

      if (this.differenceOfTimeInMinutes(message.createdAt, messages[index - 1].createdAt) > 20) {
        return formatDate(
          message.createdAt,
          "HH:mm",
          {
            locale: ptBR,
          }
        )
      }
      return false
    },
    readAllMessages(){
      if (this.hasUnreadMessagesByMe){
        this.$emit("mark-as-read", this.selectedProfessional)
      }
    },
    handleMessageKeyDown(event){
      if ((event.shiftKey || event.ctrlKey) && event.key === 'Enter' && this.messageRows < 5) {
        this.messageRows++;
        return
      }

      if (event.key === 'Enter') {
        event.preventDefault();
        this.sendMessage();
      }
    }
  },
  computed: {
    hasUnreadMessagesByMe(){
      return this.selectedProfessional.unread_messages_count > 0
    },
    groupedMessages(){
      if (this.selectedProfessional.messages.length === 0) {
        return []
      }
      const grouped = {};
      for (const message of this.selectedProfessional.messages) {
        message.createdAt = new Date(message.created_at)
        message.createdAtForTitle = formatDatePtBr(message.createdAt, "HH:mm")
        const date = this.formatDate(message.createdAt)
        if (!grouped[date]) {
          grouped[date] = [];
        }
        grouped[date].push(message);
      }
      return Object.entries(grouped).map(([date, messages]) => ({ date, messages }));
    }
  }
};
</script>
